import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// 推荐 0 为头图
const article1 = {
  'title': '从流量场到生意场，小微企业养成记',
  'second_title': '中国新闻周刊 x 动见',
  'brief': '从这场复苏里，可以捕捉中国经济率先在全球企稳回正的密码',
  'shortbrief': '改革开放40多年来，很少见到这样的一幕。',
  'share_title': '从流量场到生意场，小微企业养成记',
  'share_des': '从这场复苏里，可以捕捉中国经济率先在全球企稳回正的密码',
  'date': '2021-01-07'
}
// 推荐 开始

const article2 = {
  'title': '被争夺的中小微企业和被忽略的真实',
  'second_title': '中国新闻周刊 x 动见',
  'brief': '诚然，数字化为中小微企业带来了诸多机遇，但是中小微企业的成长从来不是一蹴而就，它需要多方配合，从生态的高度共同推进。',
  'shortbrief': '诚然，数字化为中小微企业带来了诸多机遇，但是中小微企业的成长从来不是一蹴而就，它需要多方配合，从生态的高度共同推进。',
  'share_title': '被争夺的中小微企业和被忽略的真实',
  'share_des': '诚然，数字化为中小微企业带来了诸多机遇，但是中小微企业的成长从来不是一蹴而就，它需要多方配合，从生态的高度共同推进',
  'date': '2021-01-07'
}
const article3 = {
  'title': '用户的生活场，小微企业的生意场',
  'second_title': '中国新闻周刊 x 动见',
  'brief': '平台之于小微企业，是伙伴、是朋友。从生活到生意的全场景演进，不仅是立足于平台自身，更是巨量引擎立足于帮助小微企业突破增长天花板的使命所在。',
  'shortbrief': '平台之于小微企业，是伙伴、是朋友。从生活到生意的全场景演进，不仅是立足于平台自身，更是巨量引擎立足于帮助小微企业突破增长天花板的使命所在。',
  'share_title': '用户的生活场，小微企业的生意场',
  'share_des': '平台之于小微企业，是伙伴、是朋友。从生活到生意的全场景演进，不仅是立足于平台自身，更是巨量引擎立足于帮助小微企业突破增长天花板的使命所在',
  'date': '2021-01-07'
}

const article4 = {
  'title': '数说：本地生活企业“生意经”',
  'second_title': '中国新闻周刊 x 动见',
  'brief': '',
  'shortbrief': '通过数据展示本地生活企业的营销趋势，以及平台如何利用产品与服务，帮助商家打造从流量场到生意场的长效经营模式。 ',
  'share_title': '数说：本地生活企业“生意经”',
  'share_des': '通过数据展示本地生活企业的营销趋势，以及平台如何利用产品与服务，帮助商家打造从流量场到生意场的长效经营模式',
  'date': '2021-01-07'
}
// 推荐 结束

//  见解 开始
const article5 = {
  'title': '数字技术普惠下，“中小微”才有大作为',
  'second_title': '',
  'brief': '企业通过互联网数字技术，在环环相扣的产业链条中抓住关键痛点，再通过一个点连成“一条线”，从而带动中小企业的“一个面”，是数字技术实现普惠的基本逻辑。',
  'shortbrief': '企业通过互联网数字技术，在环环相扣的产业链条中抓住关键痛点，再通过一个点连成“一条线”，从而带动中小企业的“一个面”，是数字技术实现普惠的基本逻辑。',
  'share_title': '数字技术普惠下，“中小微”才有大作为',
  'share_des': '企业通过互联网数字技术，在环环相扣的产业链条中抓住关键痛点，再通过一个点连成“一条线”，从而带动中小企业的“一个面”，是数字技术实现普惠的基本逻辑',
  'date': '2021-01-07'
}
const article6 = {
  'title': '新平台经济：助力中小微企业破局与出圈',
  'second_title': '',
  'brief': '平台不仅是工具，更是建立一个开放共赢的商业生态的基础，和触发中小微企业增长的“新引擎”。',
  'shortbrief': '平台不仅是工具，更是建立一个开放共赢的商业生态的基础，和触发中小微企业增长的“新引擎”。',
  'share_title': '新平台经济：助力中小微企业破局与出圈',
  'share_des': '平台不仅是工具，更是建立一个开放共赢的商业生态的基础，和触发中小微企业增长的“新引擎',
  'date': '2021-01-07'
}

//  见解 结束

// 案例实践
const article7 = {
  'title': '从"流量"到"留量"，本地农业+的创新发展',
  'second_title': '中国新闻周刊 x 动见',
  'brief': '将转瞬即逝的“流量”变为得以长期转化的“留量”的关键是粉丝经营。',
  'shortbrief': '将转瞬即逝的“流量”变为得以长期转化的“留量”的关键是粉丝经营。',
  'share_title': '从"流量"到"留量"，本地农业+的创新发展',
  'share_des': '将转瞬即逝的“流量”变为得以长期转化的“留量”的关键是粉丝经营',
  'date': '2021-01-07'
}
const article8 = {
  'title': '打造直播助农方法论，“造血助农”新模式',
  'second_title': '中国新闻周刊 x 动见',
  'brief': '数字化经济发展的背景下，短视频平台的流量聚集以及地方政府和商家发挥“互联网+特产”的上行作用，正在为产业扶贫带来新思路与新方法。',
  'shortbrief': '数字化经济发展的背景下，短视频平台的流量聚集以及地方政府和商家发挥“互联网+特产”的上行作用，正在为产业扶贫带来新思路与新方法。',
  'share_title': '打造直播助农方法论，“造血助农”新模式',
  'share_des': '数字化经济发展的背景下，短视频平台的流量聚集以及地方政府和商家发挥“互联网+特产”的上行作用，正在为产业扶贫带来新思路与新方法',
  'date': '2021-01-07'
}
const article9 = {
  'title': '线上+线下，本地文旅企业如何“网红”变“长红”？”',
  'second_title': '中国新闻周刊 x 动见',
  'brief': '“网红”变“长红”，最终考验的是线上+线下的运营能力和调试能力。',
  'shortbrief': '“网红”变“长红”，最终考验的是线上+线下的运营能力和调试能力。',
  'share_title': '线上+线下，本地文旅企业如何“网红”变“长红”？',
  'share_des': '“网红”变“长红”，最终考验的是线上+线下的运营能力和调试能力',
  'date': '2021-01-07'
}
const article10 = {
  'title': '阵地经营，小微企业长效经营之路怎么走？',
  'second_title': '中国新闻周刊 x 动见',
  'brief': '生意场的突围，离不开行之有效的内容营销方法论和一个长效经营的阵地。',
  'shortbrief': '生意场的突围，离不开行之有效的内容营销方法论和一个长效经营的阵地',
  'share_title': '阵地经营，小微企业长效经营之路怎么走？',
  'share_des': '生意场的突围，离不开行之有效的内容营销方法论和一个长效经营的阵地',
  'date': '2021-01-07'
}
const article11 = {
  'title': '提升用户思维，酒店餐饮如何造“爆品”？',
  'second_title': '中国新闻周刊 x 动见',
  'brief': '疫情就像一场大考，积极走出舒适区，转变营销思路，才能在危机中找到长效经营之道。',
  'shortbrief': '疫情就像一场大考，积极走出舒适区，转变营销思路，才能在危机中找到长效经营之道。',
  'share_title': '提升用户思维，酒店餐饮如何造“爆品”？',
  'share_des': '疫情就像一场大考，积极走出舒适区，转变营销思路，才能在危机中找到长效经营之道',
  'date': '2021-01-07'
}
// 专家叫见解s

export default new Vuex.Store({
  state: {
    articles: [
      article1, article2, article3, article4, article5,
      article6, article7, article8, article9, article10,
      article11
    ],
    classes: ["推荐", "实践", "见解", ],
    class1: {
      marquees: [0],
      banner: [],
      list: [1, 2, 3]
    },
    class2: {
      marquees: [],
      banner: [],
      list: [7, 8, 9, 10, 6]
    },
    class3: {
      marquees: [],
      banner: [],
      list: [4,5]
    }
  },
  mutations: {}
})



// WEBPACK FOOTER //
// ./src/store/articlesStore_3.js